<div class="schedule-container">
    <div class="schedules-container">
        <div class="empty-message" *ngIf="emptySchedules">
            <span class="schedule-label">{{ scheduleIsEmptyMessage }}</span>
        </div>
        <div class="schedules" *ngIf="!emptySchedules">
            <div class="schedule-list"
                [ngClass]="scheduleTypeClassName[scheduleType]"
                *ngFor="let scheduleType of scheduleKeys">
                <ng-container *ngIf="scheduleLabels[scheduleType]">
                    <div class="schedule-label" *ngIf="!scheduleTypeLinks[scheduleType]; else scheduleTypeLink">
                        {{ scheduleLabels[scheduleType] }} <span *ngIf="scheduleService.displayScheduleList(scheduleType)">&#8211;&nbsp;</span>
                    </div>
                    <ng-template #scheduleTypeLink>
                        <div>
                            <finder-anchor
                                [href]="scheduleTypeLinks[scheduleType]"
                            >
                            {{ scheduleLabels[scheduleType] }}
                            </finder-anchor>
                            <span *ngIf="scheduleService.displayScheduleList(scheduleType)"> &#8211;&nbsp;</span>
                        </div>
                    </ng-template>
                </ng-container>
                <finder-meal-period
                    *ngIf="mealPeriodSchedules; else scheduleList"
                    [scheduleType]="scheduleType"
                    [mealPeriodsOrder]="mealPeriodsOrder"
                    [mealPeriods]="mealPeriodScheduleService.mealPeriodsData.mealPeriods"
                    [schedules]="mealPeriodSchedules"
                    [labels]="mealPeriodScheduleService.mealPeriodsData.labels"
                    [layout]="layouts.simple">
                </finder-meal-period>
                <ng-template #scheduleList>
                    <finder-schedule-list
                        *ngIf="scheduleService.displayScheduleList(scheduleType)"
                        class="schedule-list"
                        [separator]="scheduleToLabel"
                        [separatorLabel]="scheduleAndLabel"
                        [times]="scheduleGroups[scheduleType]">
                    </finder-schedule-list>
                </ng-template>
            </div>
        </div>
        <finder-button
            *ngIf="showViewMore"
            anchor="true"
            [title]="showtimesModalLinkTitle"
            (keydown.enter)="openShowtimesModal()"
            (click)="openShowtimesModal()">
                {{ showtimesModalLinkName }}
        </finder-button>
    </div>
</div>
